import { Modal } from '@/components/Layout';
import React from 'react';
import { useEstablishments } from '../../hooks';
import { Button } from '@/components/Common';
import { useEstablishmentStore } from '@/store/EstablishmentStore/EstablishmentStore';

const EstablishmentDeletionModal = () => {
  const { onDesactivateEstablishment, isUpdatingSchool, deactivationMode } =
    useEstablishments();
  const { isOpenEstablishmentDeletionModal, closeEstablishmentDeletionModal } =
    useEstablishmentStore();

  const isDeactivating = deactivationMode === 'deactivate';
  const title = isDeactivating
    ? 'Désactiver un établissement'
    : 'Réactiver un établissement';
  const confirmMessage = isDeactivating
    ? 'Confirmez la désactivation'
    : 'Confirmez la réactivation';
  const actionText = isUpdatingSchool
    ? isDeactivating
      ? 'Désactivation...'
      : 'Réactivation...'
    : 'Oui';

  return (
    <Modal
      isOpen={isOpenEstablishmentDeletionModal}
      onClose={closeEstablishmentDeletionModal}
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-white text-xl font-bold text-center mb-2">
          {title}
        </h3>
        <p className="text-center text-gray-400 mx-auto my-0">
          {confirmMessage}
        </p>
        <div className="flex justify-between items-center gap-6 mt-4">
          <Button
            onClick={closeEstablishmentDeletionModal}
            title="Non"
            disabled={isUpdatingSchool}
            className="!bg-completed hover:!outline-completed hover:!text-completed
                hover:!bg-hoverColor text-white !px-16"
          />
          <Button
            className="!px-16"
            title={actionText}
            onClick={onDesactivateEstablishment}
            disabled={isUpdatingSchool}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EstablishmentDeletionModal;
